var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-widget',{attrs:{"title":"Notes"}},[_c('notes',{attrs:{"notes":_vm.notes,"loading":_vm.notesLoading},on:{"add-note":_vm.addNote}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }